import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Search, Star, WifiOff } from 'lucide-react';

const features = [
  { icon: BookOpen, title: 'Acces Complet', desc: 'Tous les textes juridiques congolais en un seul endroit' },
  { icon: Search, title: 'Recherche Rapide', desc: 'Trouvez rapidement les lois et articles dont vous avez besoin' },
  { icon: Star, title: 'Favoris', desc: 'Sauvegardez vos textes importants pour y acceder rapidement' },
  { icon: WifiOff, title: 'Mode Hors Ligne', desc: 'Accedez a vos contenus meme sans connexion internet' },
];

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="app-layout" style={{ justifyContent: 'center' }}>
      <div style={{ padding: '40px 24px 32px', textAlign: 'center' }}>
        <div className="icon-circle lg" style={{ margin: '0 auto 24px' }}>
          <BookOpen />
        </div>
        <h1 style={{ fontSize: '28px', fontWeight: 800, color: 'var(--primary)', marginBottom: '6px' }}
            data-testid="landing-title">
          Droit Congolais
        </h1>
        <p style={{ fontSize: '15px', color: 'var(--text-gray)', marginBottom: '4px', fontWeight: 500 }}>
          Republique Democratique du Congo
        </p>
        <p style={{ fontSize: '14px', color: 'var(--text-light)', lineHeight: 1.5, maxWidth: '320px', margin: '0 auto' }}>
          Votre guide juridique mobile complet pour acceder a tous les textes de loi congolais
        </p>
      </div>

      <div style={{ padding: '0 24px' }}>
        {features.map(({ icon: Icon, title, desc }) => (
          <div className="feature-card" key={title} data-testid={`feature-${title.toLowerCase().replace(/\s/g, '-')}`}>
            <div className="icon-circle">
              <Icon />
            </div>
            <div className="feature-card-text">
              <h3>{title}</h3>
              <p>{desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div style={{ padding: '28px 24px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <button
          className="btn-primary"
          onClick={() => navigate('/accueil')}
          data-testid="explore-btn"
        >
          Explorer les textes
        </button>
        <button
          className="btn-outline"
          onClick={() => navigate('/assistant')}
          data-testid="assistant-btn"
        >
          Assistant IA Juridique
        </button>
        <p style={{ textAlign: 'center', fontSize: '13px', color: 'var(--text-light)', marginTop: '4px' }}>
          Acces gratuit aux textes juridiques officiels de la RDC
        </p>
      </div>
    </div>
  );
};

export default LandingPage;
